<template>  
  <VUEModal :Titolo="Titolo" 
            :Programma="''" 
            :Altezza="AltezzaPopup" 
            :Larghezza="'500px'" 
            :PathLogo="require('@/assets/images/LogoDMS.png')"
            @onClickChiudiModal="OnClickChiudiModal"
            @OnClickConfermaModal="OnClickConfermaModal">

    <template v-slot:Body>
      
    <div style="float:left;" :style="{'width' : SelezionaTotale ? '65%' : '100%'}">
      <div class="ZMSeparatoreScheda" style="margin-bottom:0px;margin-top:0px" :style="{'background-color' : ColoriPantone.Marrone }">
        <text style="font-weight: bold;">{{ this.GetTraduzioneLabel('Generic','TKN_MODULI',this.LinguaUtente) }}</text>
      </div>
      <div style="overflow:auto" :style="{'max-height': (parseInt(AltezzaPopup) - 50) + 'px'}">
        
        <div v-if="IsGraficoConTotali" :style="{'background-color' : ColoriSfondo.Arancione }">
          <div style="float:left;width:3%;">&nbsp;</div>
          <input style="float:left;width:4.5%;margin:0px" type="checkbox" class="form-control" @change="TotaleSelezionato($event.target.checked)" v-model="SelezionaTotale"/>
          <div style="float:left;width:4%;">&nbsp;</div>
          <text style="float:left;width:45%;margin-top:6px;font-size:16px">{{ this.GetTraduzioneLabel('Generic','TKN_TOTALE',this.LinguaUtente) }}</text>
          <div class="ZMColorPickerDiv" style="float:left;width:40%;margin-top:8px;" :style="{'background-color' : ColorTotale}" @click="ApriPopupColorPicker(-1)">&nbsp;</div>
          <div style="clear:both"></div>
        </div>

        <template v-for="(OggettoModulo, index) in ModuliDisponibili" :key="index">
          <div :style="{'background-color' : (IsGraficoConTotali ? (index % 2 != 0) : (index % 2 == 0)) ? ColoriSfondo.Arancione : 'white' }">
            <div style="float:left;width:3%;">&nbsp;</div>
            <input style="float:left;width:4.5%;margin:0px" type="checkbox" class="form-control" @change="SelezionaModulo(index, $event.target.checked)" v-model="OggettoModulo.Selezionato"/>
            <div style="float:left;width:4%;">&nbsp;</div>
            <text style="float:left;width:45%;margin-top:6px;font-size:16px"> {{ this.GetTraduzioneLabel('Generic','TKN_MOD_N',this.LinguaUtente) }} {{ OggettoModulo.Id }}</text>
            <div v-if="ShowColori" class="ZMColorPickerDiv" style="float:left;width:40%;margin-top:8px;" :style="{'background-color' : OggettoModulo.Colore}" @click="ApriPopupColorPicker(index)">&nbsp;</div>
            <div style="clear:both"></div>
          </div>
        </template>
      </div>
    </div>
    
    <div v-if="SelezionaTotale" style="width:35%;float:left" ref="DivPulsanti">
      <div style="float:left;width:4%;">&nbsp;</div>
      <div style="float:left;width:96%">
        <button @click="OnClickSelezionaTuttiModuli" type="button" class="btn btn-info" style="width:100%">{{ this.GetTraduzioneLabel('Generic','TKN_TUTTI',this.LinguaUtente) }}</button>
      </div>
      <div style="clear:both;height:4px"></div>
      <div style="float:left;width:4%;">&nbsp;</div>
      <div style="float:left;width:96%">
        <button @click="OnClickDeselezionaTuttiModuli" type="button" class="btn btn-info" style="width:100%">{{ this.GetTraduzioneLabel('Generic','TKN_NESSUNO',this.LinguaUtente) }}</button>
      </div>
      <div style="clear:both;height:4px"></div>
      <div style="float:left;width:4%;">&nbsp;</div>
      <div style="float:left;width:96%">
        <button @click="OnClickInvertiTuttiModuli" type="button" class="btn btn-info" style="width:100%">{{ this.GetTraduzioneLabel('Generic','TKN_INVERTI',this.LinguaUtente) }}</button>
      </div>
    </div>

    </template>
   
    <template  v-slot:Footer>
      <button type="button" class="btn btn-danger" style="float:right;margin-left:10px;font-weight:bold;width:20%" @click="OnClickChiudiModal" data-dismiss="modal">{{ this.GetTraduzioneLabel('Generic','TKN_ANNULLA',this.LinguaUtente) }}</button>
      <button v-if="CanRecord()" type="button" class="btn btn-success" style="float:right;font-weight:bold;width:20%" @click="OnClickConfermaModal"  data-dismiss="modal">{{ this.GetTraduzioneLabel('Generic','TKN_CONFERMA',this.LinguaUtente) }}</button>
    </template>
 
  </VUEModal>

  <VUEColorPicker :Popup="PopupColorPicker" Programma="DMSEW" :Colore="ColoreInModifica" @OnClickConfermaPopup="ConfermaColore()" @OnClickChiudiPopup="AnnullaColore()"></VUEColorPicker>

</template>

<script>  

import VUEModal from '@/utils/VUEModal.vue';            
import { SystemInformation, COLORI_PANTONE, SFONDO } from '@/SystemInformation'
import VUEColorPicker from '@/utils/VUEColorPicker.vue'
import MixInsGestioneTraduzioni from '@/utils/MixInsGestioneTraduzioni.js';

export default 
{
  data()
  {
   return {
            LinguaUtente           : SystemInformation.UserInformation.Lingua,
            ModuliDisponibili      : '',
            ColoriPantone          : COLORI_PANTONE,
            ColoriSfondo           : SFONDO,
            PopupFiltroProfondita  : false,
            PopupColorPicker       : false,
            CurrentIndex           : -1,
            ColoreInModifica       : {},
            SelezionaTotale        : false,
            ColorTotale            : '',
            ShowColori             : false,
          }
  },

  props : ['AltezzaPopup', 'Titolo', 'VettoreModuli', 'MostraColori', 'IsGraficoConTotali', 'MostraTotale', 'ColoreTotale'],
  emits : ['OnClickChiudiPopup', 'OnClickConfermaPopup'],
  mixins: [MixInsGestioneTraduzioni],
  components: { 
                VUEModal,
                VUEColorPicker
              },

  methods :
  {
    OnClickChiudiModal()
    {
      this.$emit('OnClickChiudiPopup')
    },

    SelezionaModulo(index, IsSelezionato)
    {
      if(!this.SelezionaTotale)
        this.ModuliDisponibili.forEach((Modulo, i) => {Modulo.Selezionato = (i == index) ? IsSelezionato : false})
    },

    TotaleSelezionato(IsSelezionato)
    {
      if(!IsSelezionato)
      {
        this.ModuliDisponibili.forEach((Modulo) => {Modulo.Selezionato = false})
      }
      this.SelezionaTotale = IsSelezionato;
      this.ShowColori = !IsSelezionato
    },

    OnClickSelezionaTuttiModuli()
    {
      this.ModuliDisponibili.forEach((Modulo) => {Modulo.Selezionato = true})
    },

    OnClickDeselezionaTuttiModuli()
    {
      this.ModuliDisponibili.forEach((Modulo) => {Modulo.Selezionato = false})
    },

    OnClickInvertiTuttiModuli()
    {
      this.ModuliDisponibili.forEach((Modulo) => {Modulo.Selezionato = !Modulo.Selezionato})
    },

    ApriPopupColorPicker(Index)
    {
      if(Index == -1)
      {
        this.CurrentIndex = Index
        this.ColoreInModifica.Colore = this.ColorTotale
        this.ColoreInModifica.ModuloInModifica = this.ColorTotale
        this.PopupColorPicker = true
      }
      else
      {
        this.CurrentIndex = Index
        this.ColoreInModifica.Colore = this.ModuliDisponibili[Index].Colore
        this.ColoreInModifica.ModuloInModifica = this.ModuliDisponibili[Index].Colore
        this.PopupColorPicker = true
      }
    },

    ConfermaColore()
    {
      if(this.CurrentIndex == -1)
      {
        this.ColorTotale = this.ColoreInModifica.Colore
      }
      else
      {
        this.ModuliDisponibili[this.CurrentIndex].Colore = this.ColoreInModifica.Colore
      }
      this.AnnullaColore()
    },

    AnnullaColore()
    {
      this.ColoreInModifica = {}
      this.PopupColorPicker = false
    },

    OnClickConfermaModal()
    {
      this.$emit('OnClickConfermaPopup', this.ModuliDisponibili, this.ColorTotale, this.SelezionaTotale)
    },

    CanRecord()
    {
      let Result = this.ModuliDisponibili.some((Modulo) => Modulo.Selezionato)
      return Result
    },
  },

  beforeMount()
  {
    this.ModuliDisponibili = JSON.parse(JSON.stringify(this.VettoreModuli))
    this.SelezionaTotale   = this.MostraTotale
    this.ColorTotale       = this.ColoreTotale
    this.ShowColori        = this.MostraColori && !this.MostraTotale
  }
}
</script>